
import request from '@/utils/request'

// 获取用户数据
export function saveOrdelete(params) {
  return request({
    url: '/base/system/base/parttime/stations/save_or_delete',
    method: 'post',
    data: params
  })
}
export function getList(params) {
  return request({
    url: '/base/system/base/parttime/stations/get_list',
    method: 'get',
	params
  })
}
